import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"

import { FloorInput } from "entities/floors/ui"

import { useRoomFormContext } from "../../contexts/RoomFormContext"

export interface RoomFloorInputProps extends WithClassName {
  hideLabel?: boolean
}

export const RoomFloorInput = React.memo(
  ({ className }: RoomFloorInputProps) => {
    const { isReadonly, isDisabled, floorOptions, isLoadingFloorOptions } =
      useRoomFormContext()

    return (
      <FloorInput
        name="parentID"
        className={classNames("room-form__floor", className)}
        readonly={isReadonly}
        disabled={isDisabled}
        options={floorOptions}
        loading={isLoadingFloorOptions}
      />
    )
  }
)
